//@ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { flatten } from 'lodash';
import dataTestValue from '../../../../../utils/testUtils';

class SimpleDataTable extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        recordClassName: PropTypes.func,
        header: PropTypes.bool,
        columns: PropTypes.any,
        data: PropTypes.any,
        corrIds: PropTypes.any,
        config: PropTypes.object,
        expanded: PropTypes.func,
        splitRow: PropTypes.func
    };

    static defaultProps = {
        header: false,
        config: {}
    };

    constructor(props, context) {
        super(props, context);
        this.tableRef = React.createRef(null);
        this.state = {
            currentWidth: null,
            expandedRecords: []
        };
    }

    componentDidMount() {
        this.listener = () => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.updateWidth();
            }, 180);
        };

        window.addEventListener('resize', this.listener);

        this.updateWidth();
    }

    componentDidUpdate() {
        this.updateWidth();
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);

        if (this.listener && typeof window !== 'undefined') {
            window.removeEventListener('resize', this.listener);
        }
    }

    updateWidth() {
        const currentWidth = this.tableRef.current?.offsetWidth ?? 0;
        if (currentWidth === this.state.currentWidth) {
            return;
        }

        this.setState({
            currentWidth
        });
    }

    hasEnoughImportance(column) {
        const { currentWidth } = this.state;
        return currentWidth === null || currentWidth >= column.minWidth;
    }

    getRecordClassName(record, index) {
        const classes = [
            `simple-data-table__row--index-${ index}`
        ];

        if (this.state.expandedRecords.includes(record.id)) {
            classes.push('simple-data-table__row--expanded');
        }

        if (this.props.recordClassName) {
            classes.push(this.props.recordClassName(record));
        }

        return classes.join(' ');
    }

    getColumnClassName(column, record) {
        const className = [ column.name ];

        if (column.className) {
            if (typeof column.className === 'function') {
                const columnClass = column.className(record);

                if (columnClass) {
                    className.push(columnClass);
                }
            } else {
                className.push(column.className);
            }
        }

        return classNames([
            column.name,
            typeof column.className === 'function' ? column.className(record) : column.className
        ]);
    }

    toggle(id) {
        const { expandedRecords } = this.state;
        const idx = expandedRecords.indexOf(id);

        if (idx === -1) {
            expandedRecords.push(id);
        } else {
            expandedRecords.splice(idx, 1);
        }

        this.setState({
            expandedRecords: expandedRecords.slice()
        });
    }

    render() {
        const { columns, data, corrIds, className, header, config, expanded, splitRow } = this.props;
        const { expandedRecords, currentWidth } = this.state;

        if (currentWidth === null) {
            return <div />;
        }
        const cols = columns.filter((column) => this.hasEnoughImportance(column));

        let expandableHeaderCol;
        if (expanded) {
            expandableHeaderCol = <th />;
        }

        let headerEl;
        if (header) {
            headerEl = (
                <thead>
                    <tr>
                        {
                            cols.map(column => {
                                return (
                                    <th
                                        className={ this.getColumnClassName(column) }
                                        key={ column.name }
                                    >
                                        { column.label }
                                        <div>{ column.label }</div>
                                    </th>
                                );
                            })
                        }
                    </tr>
                </thead>
            );
        }

        const containerClassName = [ 'simple-data-table-container' ];

        if (className) {
            containerClassName.push(className);
        }

        if (headerEl) {
            containerClassName.push('simple-data-table-container--header');
        }

        return (
            <div className={ containerClassName.join(' ') } ref={this.tableRef}>
                <div className='simple-data-table-inner-container'>
                <table className='simple-data-table'>
                    { headerEl }
                    <tbody>
                    {
                        flatten(data.map((record, key) => {
                            const innerData = (splitRow && splitRow(record)) || [ record ];
                            const isExpanded = expanded && expandedRecords.includes(record.id) && record.type !== 'SGL';

                            let rows = innerData.map((innerRecord, innerIndex) => (
                                <tr
                                    key={ `${key }-${ innerIndex}` }
                                    className={ this.getRecordClassName(innerRecord, innerIndex), corrIds.indexOf(innerRecord.correlationID) % 2 == 0 ? 'even-group' : 'odd-group' }
                                    onClick={
                                        (e) => {
                                            e.preventDefault();
                                            if (record.type !== 'SGL'){
                                                this.toggle(record.id);

                                            }
                                        }
                                    }
                                    data-test={ dataTestValue(record.id) }
                                >
                                    {
                                        cols.map(column => {
                                            return (
                                                <td
                                                    className={ this.getColumnClassName(column, innerRecord)}
                                                    style={ column.style ? column.style(innerRecord, config) : void 0 }
                                                    key={ column.name }
                                                >
                                                    {
                                                        column.value ?
                                                            column.value(innerRecord) :
                                                            innerRecord[column.name]
                                                    }
                                                </td>
                                            );
                                        })
                                    }
                                </tr>
                            ));


                            if (isExpanded) {
                                const expandedRow = expanded(record);
                                rows = expandedRow.map((innerRecord, innerIndex) => (
                                    <tr
                                        key={ `${key }-${ innerIndex}` }
                                        className={ this.getRecordClassName(innerRecord, innerIndex), innerIndex === 0 ? (corrIds.indexOf(innerRecord.correlationID) % 2 == 0 ? 'even-group' : 'odd-group') : 'expanded-group' }
                                        data-test={ dataTestValue(record.id) }
                                        onClick={
                                            (e) => {
                                                e.preventDefault();
                                                if (record.type !== 'SGL') {
                                                    this.toggle(record.id);
                                                }
                                            }
                                        }

                                    >
                                        {
                                            cols.map(column => {
                                                return (
                                                    <td
                                                        className={ this.getColumnClassName(column, innerRecord)}
                                                        style={ column.style ? column.style(innerRecord, config) : void 0 }
                                                        key={ column.name }
                                                    >
                                                        {
                                                            column.value ?
                                                                column.value(innerRecord) :
                                                                innerRecord[column.name]
                                                        }
                                                    </td>
                                                );
                                            })
                                        }
                                    </tr>
                                ));
                            }

                            return rows;
                        }))
                    }
                    </tbody>
                </table>
                </div>
            </div>
        );
    }
}

export default SimpleDataTable;
